<div class="page-container main-font pl-0 pr-0">
  <div class="content-container mt-3 w-100">
    <div class="filter-container w-100">
      <div class="d-flex flex-column w-100">
        <p class="mb-0 text-filter">Utenti</p>
        <nz-select
          class="w-100"
          nzMode="multiple"
          [(ngModel)]="usersSelected"
          (ngModelChange)="onSelectUser($event)"
          [nzMaxTagCount]="1"
          [nzAllowClear]="true"
          [nzPlaceHolder]="'Cerca'">
          <nz-option
            *ngFor="let user of activeUsers"
            [nzValue]="user.id"
            [nzLabel]="user.first_name + ' ' + user.last_name">
          </nz-option>
        </nz-select>
      </div>
      <div class="d-flex flex-column w-100">
        <p class="mb-0 text-filet">Seleziona team</p>
        <nz-select
          [nzPlaceHolder]="'Seleziona'"
          [nzAllowClear]="true"
          [(ngModel)]="teamsSelected"
          nzMode="multiple"
          [nzMaxTagCount]="1"
          [nzAllowClear]="true"
          (ngModelChange)="onSelectTeam($event)">
          <nz-option
            *ngFor="let team of teams"
            [nzValue]="team.id"
            [nzLabel]="team.alias">
          </nz-option
        ></nz-select>
      </div>
      <div class="d-flex flex-column w-100">
        <p class="mb-0 text-filet">Seleziona ruolo</p>
        <nz-select
          class="w-100"
          [nzPlaceHolder]="'Seleziona'"
          [(ngModel)]="rolesSelected"
          nzMode="multiple"
          [nzMaxTagCount]="1"
          [nzAllowClear]="true"
          (ngModelChange)="onSelectRole($event)">
          <nz-option
            *ngFor="let role of roles"
            [nzValue]="role.value"
            [nzLabel]="role.label">
          </nz-option>
        </nz-select>
      </div>
      <button
        class="primary-btn w-100 d-flex align-items-center justify-content-center gap-2"
        (click)="openSeatsModal()">
        <i class="option"></i> Gestisci disponibilità
      </button>
    </div>
    <div class="table-container my-scrollbar">
      <table>
        <thead>
          <tr class="table-header">
            <th class="d-flex pt-3">
              <!-- solo per la prima colonna, che è quella del mese -->
              <div class="month-container" *ngIf="listOfColumns.length > 0">
                <button
                  (click)="confirmEventsOrPublishCalendar()"
                  [disabled]="!isDraftEvents && !isDraftMonth"
                  class="primary-btn-new">
                  Pubblica
                </button>
                <div class="month-selected">
                  <button
                    class="transparent-btn"
                    (click)="changeMonth('prev')"
                    [disabled]="!previousMonthExist">
                    <img
                      src="assets/images/icon_calendar/left_arrow.svg"
                      alt="prev"
                      class="prev" />
                  </button>
                  <div class="text-month-container">
                    <p class="mb-0 text-month">
                      {{ getMonth(listOfColumns[15]?.date) }}
                    </p>
                  </div>
                  <button
                    class="transparent-btn"
                    *ngIf="nextMonthExist; else generateMonth">
                    <img
                      src="assets/images/icon_calendar/right_arrow.svg"
                      alt="next"
                      class="next"
                      (click)="changeMonth('next')" />
                  </button>
                  <ng-template #generateMonth>
                    <button
                      class="transparent-btn"
                      (click)="openModalGenerateMonth()">
                      <i class="icons add-filled fill-svg-blue-700"></i>
                    </button>
                  </ng-template>
                </div>
              </div>

              <!-- colonne giorni -->
              <ng-container
                *ngFor="
                  let day of listOfColumns;
                  trackBy: trackByDate;
                  let i = index;
                  let first = first;
                  let last = last
                ">
                <div class="day-container">
                  <div class="badge-counter-container">
                    <img
                      *ngIf="!day.business && !checkDayOff(i)"
                      [src]="this.getImages(day.workers, day.limit)"
                      alt="users-counter"
                      class="icon-counter" />
                    <p
                      *ngIf="!checkDayOff(i)"
                      class="mb-0 counter d-flex justify-content-end align-items-center">
                      {{ day.workers }}
                    </p>
                  </div>
                  <div class="day-week-container">
                    <button
                      (click)="
                        !day.business
                          ? openDayTypeModal(
                              day.date,
                              day.limit,
                              rowDaysSmart[i]?.dayType,
                              i
                            )
                          : ''
                      "
                      class="day-cell cell-btn bg-blue"
                      [style]="{
                        'border-radius': first
                          ? '8px 0px 0px 0px'
                          : last
                            ? '0px 8px 0px 0px'
                            : '0px',
                        cursor: !day.business ? 'pointer' : 'default'
                      }">
                      <p class="mb-0 day-text">{{ day?.date | date: 'd' }}</p>
                    </button>
                    <div class="day-cell bg-blue2">
                      <p class="mb-0 day-text">
                        {{ day.weekdayLetter }}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row-smart d-flex">
            <td class="smart-cell">
              <button
                *ngIf="!isSmartEdit"
                class="transparent-btn edit-btn d-flex gap-1"
                (click)="enableSmartEdit()">
                <img
                  src="assets/images/icon_calendar/edit.svg"
                  alt="edit"
                  class="edit-icon" />
                <p class="mb-0">Modifica</p>
              </button>
              <button
                *ngIf="isSmartEdit"
                class="transparent-btn close-edit-btn"
                (click)="disableSmartEdit()">
                Chiudi modifica
              </button>
            </td>
            <td
              *ngFor="let day of rowDaysSmart; let i = index"
              class="day-cell-smart">
              <label
                *ngIf="!day.business && day?.dayType != 1"
                nz-checkbox
                [nzDisabled]="!isSmartEdit"
                [(ngModel)]="day.workMode"
                (ngModelChange)="setIsDaySmart(i, $event)"></label>
            </td>
          </tr>
          <tr
            *ngFor="
              let user of users;
              trackBy: trackByUserId;
              let first = first;
              let last = last
            "
            class="row-user d-flex"
            [style]="{
              'border-radius': first
                ? '8px 0px 0px 0px'
                : last
                  ? '0px 0px 8px 8px'
                  : '0px',
              'border-bottom': last ? '0.5px solid var(--Grey-3, #C2C8D4)' : ''
            }">
            <td class="user-cell">
              <div class="user-container">
                <img
                  *ngIf="isSmartExceeded(user, user.max_smart_days)"
                  nz-popover
                  [nzPopoverPlacement]="'left'"
                  [nzPopoverContent]="contentTemplate"
                  [nzPopoverTrigger]="'click'"
                  src="assets/images/icon_calendar/error.svg"
                  class="cursor-pointer"
                  alt="" />
                <ng-template #contentTemplate>
                  <div class="pop-container main-font">
                    <div class="pop-title-container">
                      <img
                        src="assets/images/icon_calendar/not_allowed.svg"
                        alt=""
                        class="icon-not-allowed" />
                      <p class="mb-0 title-pop">
                        Limite di smart working superato
                      </p>
                    </div>
                    <div class="pop-content">
                      <p class="mb-0 pop-text-content">
                        Questo utente, in base al suo contratto, ha già
                        raggiunto
                        <b>il numero massimo di giornate remote</b> per una
                        delle settimane. Modificare la settimana evidenziata in
                        rosso
                      </p>
                    </div>
                  </div>
                </ng-template>
                <img
                  [src]="_utilityService.getSanitizeUrl(user.path)"
                  [alt]="user.first_name"
                  class="user-image" />
                <button
                  class="transparent-btn"
                  (click)="openModalSetMaxSmart(user)">
                  <p class="mb-0 text-user">
                    {{ user.first_name }} {{ user.last_name }}
                  </p>
                </button>
              </div>
              <div class="projects-container">
                <div class="project">
                  <img
                    *ngFor="let project of user.firstThreeProjects"
                    [src]="_utilityService.getSanitizeUrl(project.path)"
                    [alt]="project.alias"
                    class="project-image"
                    [nz-tooltip]="project.alias" />
                </div>
                <div *ngIf="getOtherProject(user).length">
                  <p
                    class="other-text mb-0 cursor-pointer"
                    nz-dropdown
                    nzTrigger="click"
                    [nzDropdownMenu]="projectMenu">
                    +{{ getOtherProject(user).length }}
                  </p>
                  <nz-dropdown-menu #projectMenu="nzDropdownMenu">
                    <ul nz-menu>
                      <li
                        nz-menu-item
                        *ngFor="let project of getOtherProject(user)">
                        {{ project.alias }}
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>
              </div>
              <div class="smart-container">
                <i class="icons smart fill-svg-blue-800"></i>
                <p class="mb-0 text-max-smart">
                  {{ user.desired_smart_days }}/{{ user.max_smart_days }}
                </p>
              </div>
            </td>
            <td
              *ngFor="let day of user.days; let i = index"
              class="day-cell border-cell"
              [ngClass]="{
                'error-cell':
                  countWeeklySmart(user, day.date) > user.max_smart_days &&
                  !isWeekend(day.date),
                'missing-cell':
                  countWeeklySmart(user, day.date) < user.desired_smart_days &&
                  !isWeekend(day.date)
              }"
              [style]="{
                background:
                  isWeekend(day.date) || checkDayOff(i)
                    ? 'var(--Grey-100, #EBEDF1) !important'
                    : ''
              }">
              <ng-container *ngIf="!isWeekend(day.date) && !checkDayOff(i)">
                <div
                  [ngSwitch]="day.event.workMode"
                  nz-dropdown
                  nzTrigger="click"
                  [nzDropdownMenu]="smartMenu">
                  <img
                    *ngSwitchCase="14"
                    src="assets/images/icon_calendar/office_disabled.svg"
                    alt="office"
                    class="icon-smart"
                    [ngClass]="{ 'cursor-pointer': isSmartEdit }" />
                  <img
                    *ngSwitchCase="2"
                    src="assets/images/icon_calendar/smart.svg"
                    alt=""
                    class="icon-smart"
                    [ngClass]="{ 'cursor-pointer': isSmartEdit }" />
                  <img
                    *ngSwitchCase="3"
                    src="assets/images/icon_calendar/morning_smart.svg"
                    alt="morning"
                    class="icon-smart"
                    [ngClass]="{ 'cursor-pointer': isSmartEdit }" />
                  <img
                    *ngSwitchCase="4"
                    src="assets/images/icon_calendar/afternoon_smart.svg"
                    alt="morning"
                    class="icon-smart"
                    [ngClass]="{ 'cursor-pointer': isSmartEdit }" />
                </div>
              </ng-container>
              <nz-dropdown-menu #smartMenu="nzDropdownMenu">
                <ul
                  *ngIf="isSmartEdit && !day.business"
                  nz-menu
                  class="smart-menu">
                  <li
                    *ngFor="let option of smartOptions; let last = last"
                    nz-menu-item
                    [ngClass]="{ 'border-bottom': !last }">
                    <button
                      class="transparent-btn d-flex aling-items-center px-3 py-2 gap-2"
                      (click)="setUserDay(i, user, option.value)"
                      [disabled]="">
                      <img
                        [src]="option.img"
                        [alt]="option.label"
                        class="icon-menu" />
                      <div class="d-flex align-items-center">
                        <p class="mb-0">{{ option.label }}</p>
                        <p
                          *ngIf="option.secondaryLabel"
                          class="mb-0 text-muted">
                          {{ option.secondaryLabel }}
                        </p>
                      </div>
                    </button>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
